// JQ4-19 slice 3 · US-CONFIG-005 — useApplyComp hook
//
// Wraps POST /valet/tickets/:id/comp.
// On success: the caller applies an optimistic update from the response payload
//   (mirrors the cash payment pattern — no GET refetch).
// On error: the caller surfaces the error message in the dialog.

import { applyComp } from '@jq4race/api-client';
import { useMutation } from '@tanstack/react-query';

interface ApplyCompVars {
  ticketId: string;
  reason: string;
}

export function useApplyComp() {
  return useMutation({
    mutationFn: ({ ticketId, reason }: ApplyCompVars) => applyComp(ticketId, reason),
  });
}
